import type { FundMemberOption } from '@/types/fundMember';
/** A row of the document type list; staff can add more. */
export interface CarryDocumentType {
  id: string;
  name: string;
}

export type CarryDocumentStatus = 'MISSING' | 'AWAITING_SIGNATURE' | 'SIGNED';

export const CARRY_DOCUMENT_STATUS_LABELS: Record<CarryDocumentStatus, string> =
  {
    MISSING: 'Missing',
    AWAITING_SIGNATURE: 'Awaiting signature',
    SIGNED: 'Signed',
  };

export const CARRY_DOCUMENT_STATUSES = Object.keys(
  CARRY_DOCUMENT_STATUS_LABELS
) as CarryDocumentStatus[];

export interface CarryFundDocumentsSummary {
  fund_id: string;
  fund_name: string;
  document_statuses: {
    document_type_id: string;
    status: CarryDocumentStatus;
  }[];
}

export interface CarryDocumentSignature {
  fund_member_id: string;
  full_name: string;
  status: CarryDocumentStatus;
  signed_at: string | null;
}

export interface CarryDocumentBase {
  id: string;
  document_type: CarryDocumentType;
  title: string;
  status: CarryDocumentStatus;
  document_date: string | null;
  file_name: string | null;
}

export interface CarryDocumentAdmin extends CarryDocumentBase {
  document_id: string | null;
  published_at: string | null;
  signed_count: number;
  /** The members the document is for, each with their own signature. */
  signatures: CarryDocumentSignature[];
}

export interface CarryFundDocumentsAdmin {
  fund_id: string;
  fund_name: string;
  holders: FundMemberOption[];
  documents: CarryDocumentAdmin[];
}

export interface CarryDocumentCreate {
  document_type_id: string;
  title: string;
  fund_member_ids: string[];
  document_date: string | null;
  file: File | null;
}

export interface CarryDocumentUpdate {
  document_type_id?: string;
  title?: string;
  fund_member_ids?: string[];
  document_date?: string | null;
}
